import { isNotNil } from '@wrisk/ui-components'
import { TFunction } from 'i18next'

import { QuotePremiums } from '../../../hooks/premiums'
import {
  tCovers,
  tFormats,
  TKeyBuilder,
} from '../../../infrastructure/internationalisation'

export const coreLineItems = (
  t: TFunction,
  tKey: TKeyBuilder,
  currentPremiums: QuotePremiums,
  previousPremiums?: QuotePremiums,
) =>
  Object.entries(currentPremiums.breakdown.base).map(([code, amount]) => ({
    header: t([tKey('breakdown', code)]),
    currentAmount: t(tFormats('currency.long'), { amount }),
    previousAmount: isNotNil(previousPremiums?.breakdown.base[code])
      ? t(tFormats('currency.long'), { amount: previousPremiums.breakdown.base[code] })
      : undefined,
  }))

export const discountLineItems = (
  t: TFunction,
  tKey: TKeyBuilder,
  currentPremiums: QuotePremiums,
  previousPremiums?: QuotePremiums | undefined,
) =>
  currentPremiums.base.discount
    ? [
        {
          header: t(
            tKey(
              currentPremiums.base.premium - currentPremiums.base.discount < 0.001
                ? 'discount.full'
                : 'discount.partial',
            ),
          ),
          currentAmount: t(tFormats('currency.long'), {
            amount: -currentPremiums.base.discount,
          }),
          previousAmount:
            previousPremiums &&
            t(tFormats('currency.long'), {
              amount: -previousPremiums.base.discount,
            }),
        },
      ]
    : []

export const optionalLineItems = (
  t: TFunction,
  currentPremiums: QuotePremiums,
  previousPremiums?: QuotePremiums,
) =>
  currentPremiums.optional.map((current) => {
    const previousAmount = previousPremiums?.optional.find(
      (previous) => previous.coverOption === current.coverOption,
    )

    return {
      header: t(tCovers(current.coverOption, 'name')),
      currentAmount: t(tFormats('currency.long'), { amount: current.premium }),
      previousAmount:
        previousAmount &&
        t(tFormats('currency.long'), { amount: previousAmount.premium }),
    }
  })

export const additionalLineItems = (
  t: TFunction,
  tKey: TKeyBuilder,
  currentPremiums: QuotePremiums,
): string[] =>
  Object.entries(currentPremiums.breakdown.additional).map(([tag, amount]) =>
    t(tKey('tag', tag), {
      amount: t(tFormats('currency.long'), {
        amount,
      }),
    }),
  )
